import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import { ALL, GET_AMZ_PRODUCT_URL } from '../../common/constants';
import { getPrdReturnReason } from '../amazon.services';
import { Grid } from '@mui/material';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import Chart, { ReactGoogleChartEvent } from 'react-google-charts';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import AmazonReturnReasonComment from './return-reason-comment.component';

const ProductReturnReasonChart = () => {
  const appContext = useContext(AppContext);
  const [returnReason, setReturnReason] = useState([]);
  const [reason, setReason] = useState('');
  const [openComment, setOpenComment] = useState(false);
  const [searchData, setSearchData] = useState<any>({product: ALL});
  const options = { is3D: true, pieSliceText: 'value', sliceVisibilityThreshold: 0,
                    legend: { position: 'labeled', textStyle: { color: "purple", fontSize: 14, bold: true }},
                    pieSliceTextStyle: {color: "#ffffff", fontSize: 14, bold: false },
                    chartArea: { width: "95%", height: "90%" }};
  const chartEvents: ReactGoogleChartEvent[] = [
    {
      eventName: "select",
      callback: ({ chartWrapper }) => {
        if(!chartWrapper) return;

        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();
        if (selection.length > 0) {
          const {row} = selection[0];
          setReason(returnReason[row + 1][0]);
          setOpenComment(true);
        }
      },
    },
  ];

  useEffect(() => {
    getPrdReturnReason(searchData.product, appContext,
      (response: any) => {
        setReturnReason(response.data);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }, [searchData]);

  const search = (data: any) => {
    setSearchData(data);
  }

  const closeComment = () => {
    setOpenComment(false);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1} width={900} justifyContent="center">
        <Grid item md={4}>
          <IDropdown name='product' label='Product' url={GET_AMZ_PRODUCT_URL} allItemRequired={true} required={true}/>
        </Grid>
      </Grid>
    </SearchPanel>
  }

  return <>
    {getSearchComponent()}
    <Chart chartType="PieChart" data={returnReason} options={options} width={"100%"} height={"400px"} chartEvents={chartEvents}/>
    <IDialogComponent onClose={closeComment} open={openComment} title='Return Comment' 
      dialogBody={<AmazonReturnReasonComment product={searchData.product} reason={reason}/>} />
  </>
}

export default ProductReturnReasonChart;

